import { useNavigate } from 'react-router-dom';
import {
  Container, Title, Text, Card, Group, ThemeIcon,
  SimpleGrid, Stack, Button, Box, Divider, UnstyledButton,
} from '@mantine/core';
import {
  IconBook2, IconUser, IconArrowLeft,
  IconClipboardHeart, IconCategory, IconUsers,
  IconHeartHandshake, IconAlertCircle,
  IconMapPin,
  IconMap,
} from '@tabler/icons-react';

// ── Sidebar ───────────────────────────────────────────────────────────────────

const ALL_CATEGORIES = [
  { label: 'Acts Care Courses',    icon: IconBook2, link: '/LookUp/ActsCareCourses',    active: false },
  { label: 'Acts Care Counseling', icon: IconUser,  link: '/LookUp/ActsCareCounseling', active: false  },
  { label: 'Locations', icon: IconMapPin,  link: '/LookUp/Location', active: true  },

];

// ── Lookups in this category ──────────────────────────────────────────────────

const LOOKUPS = [
  {
    title: 'Area',
    description: 'Manage geographical areas used to organize locations and regions',
    icon: IconMapPin,
    link: '/LookUp/Location/Area',
  },
  {
    title: 'Zone',
    description: 'Manage zones within areas for location grouping and reporting',
    icon: IconMap,
    link: '/LookUp/Location/Zone',
  },
];

// ── Page ──────────────────────────────────────────────────────────────────────

export default function LocationIndexPage() {
  const navigate = useNavigate();

  return (
    <Container size="xl" py="xl">
      <Group align="flex-start" gap="xl" wrap="nowrap">

        {/* ── Sidebar ─────────────────────────────────────────────────── */}
        <Box w={220} style={{ flexShrink: 0 }}>
          <Button
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
            mb="lg"
            px={0}
            onClick={() => navigate('/LookUp')}
          >
            All Lookups
          </Button>

          <Text size="xs" fw={700} tt="uppercase" c="dimmed" mb="sm">
            Categories
          </Text>

          <Stack gap={4}>
            {ALL_CATEGORIES.map((cat) => (
              <UnstyledButton
                key={cat.label}
                onClick={() => navigate(cat.link)}
                style={(theme) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '8px 10px',
                  borderRadius: theme.radius.sm,
                  backgroundColor: cat.active
                    ? theme.colors.yellow[9] + '33'
                    : 'transparent',
                  color: cat.active
                    ? theme.colors.yellow[4]
                    : theme.colors.gray[4],
                  fontWeight: cat.active ? 600 : 400,
                })}
              >
                <ThemeIcon
                  variant={cat.active ? 'light' : 'subtle'}
                  color={cat.active ? 'yellow' : 'gray'}
                  size="sm"
                  radius="sm"
                >
                  <cat.icon size={14} />
                </ThemeIcon>
                <Text size="sm">{cat.label}</Text>
              </UnstyledButton>
            ))}
          </Stack>
        </Box>

        <Divider orientation="vertical" />

        {/* ── Main panel ──────────────────────────────────────────────── */}
        <Box style={{ flex: 1 }}>
          <Group gap="md" mb={4}>
            <ThemeIcon variant="light" color="yellow" size="lg" radius="md">
              <IconUser size={18} />
            </ThemeIcon>
            <div>
              <Title order={3}>Locations</Title>
              <Text size="sm" c="dimmed">2 lookups in this category</Text>
            </div>
          </Group>

          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mt="lg">
            {LOOKUPS.map((lookup) => (
              <Card
                key={lookup.title}
                shadow="sm"
                padding="lg"
                radius="md"
                withBorder
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(lookup.link)}
              >
                <Group gap="sm" wrap="nowrap">
                  <ThemeIcon variant="light" color="yellow" size="md" radius="md">
                    <lookup.icon size={14} />
                  </ThemeIcon>
                  <div>
                    <Text fw={600} size="sm">{lookup.title}</Text>
                    <Text size="xs" c="dimmed">{lookup.description}</Text>
                  </div>
                </Group>
              </Card>
            ))}
          </SimpleGrid>
        </Box>

      </Group>
    </Container>
  );
}